<template>
  <div>
    <v-btn @click="goBack" width="20px" text><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
    <h2 class="headerPosition">Payment Details</h2>
    <p class="headerPosition">Add your account number</p>
    <v-alert
      v-model="alert"
      type="error"
      style="text-align:start;margin:10px auto 10px auto"
      width="400px"
    >
      {{ message }}
    </v-alert>
    <v-form>
      <v-select
        color="#e50914"
        style="text-align:start;margin:auto;border-radius:10px;width:400px"
        outlined
        :items="banks"
        label="Select your bank"
        v-model="bank"
        item-value="code"
        item-text="name"
      />
      <v-text-field
        type="number"
        color="#e50914"
        outlined
        label="Enter your account number"
        v-model="accountNumber"
        @keyup="checkBank()"
        style="text-align:start;margin:auto;border-radius:10px;width:400px"
      />
      <p style="margin:auto;width:400px;text-align:start;padding:0px">Account Name</p>
      <v-text-field style="text-align:start;margin:auto;border-radius:10px;width:400px" v-model="accountName" solo readonly />
    </v-form>
    <div class="text-center">
    <v-btn
      x-large
      width="286px"
      class="mt-2 white--text"
      rounded
      color="#e50914"
      @click="toCustomization()"
      :loading="loading"
    >
      Continue
      <v-icon color="white" class="ml-2">mdi-arrow-right</v-icon>
    </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PaymentDetails",
  data() {
    return {
      accountNumber: "",
      bank: "",
      accountName: "",
      loading:false,
      message:"",
      alert:false,
      absolute:true,
      banks: [
        { id: "1", name: "Access Bank", code: "044" },
        { id: "2", name: "Citibank", code: "023" },
        { id: "3", name: "Diamond Bank", code: "063" },
        { id: "4", name: "Dynamic Standard Bank", code: "" },
        { id: "5", name: "Ecobank Nigeria", code: "050" },
        { id: "6", name: "Fidelity Bank Nigeria", code: "070" },
        { id: "7", name: "First Bank of Nigeria", code: "011" },
        { id: "8", name: "First City Monument Bank", code: "214" },
        { id: "9", name: "Guaranty Trust Bank", code: "058" },
        { id: "10", name: "Heritage Bank Plc", code: "030" },
        { id: "11", name: "Jaiz Bank", code: "301" },
        { id: "12", name: "Keystone Bank Limited", code: "082" },
        { id: "13", name: "Kuda Bank", code: "611" },
        { id: "14", name: "Providus Bank Plc", code: "101" },
        { id: "15", name: "Polaris Bank", code: "076" },
        { id: "16", name: "Stanbic IBTC Bank Nigeria Limited", code: "221" },
        { id: "17", name: "Standard Chartered Bank", code: "068" },
        { id: "18", name: "Sterling Bank", code: "232" },
        { id: "19", name: "Suntrust Bank Nigeria Limited", code: "100" },
        { id: "20", name: "Union Bank of Nigeria", code: "032" },
        { id: "21", name: "United Bank for Africa", code: "033" },
        { id: "22", name: "Unity Bank Plc", code: "215" },
        { id: "23", name: "Wema Bank", code: "035" },
        { id: "24", name: "Zenith Bank", code: "057" },
      ],
    };
  },
  computed:{
    bankName() {
      return this.banks.filter((bank) => bank.code == this.bank)[0].name;
    },
  },
  methods: {
    goBack(){
     this.$emit('goBack')
    },
    checkBank() {
      if (this.accountNumber.length == 10) {
        this.resolveBank();
      }
    },

    resolveBank() {
      this.opacity = 1;
      this.$emit('activateOverlay')
      axios({
        method: "post",
        url: "https://tips-api.herokuapp.com/bank",
        data:{
          accountNumber:this.accountNumber,
          bank:this.bank
        }
      }).then((response) => {
          if(response.data.data == null){
        this.$swal({
          title: "Bank Account not found",
          text: "Please check your account number and try again",
          icon: "error",
          button: "Try again",
        })
        this.$emit('deactivateOverlay')
        }
        else{
        this.accountName = response.data.data.account_name;
        this.$emit('deactivateOverlay')
        }
      
      })
    },

    toCustomization() {
        this.loading = true;
      if (this.accountNumber != "" && this.bank != "" && this.accountName != undefined) {
        this.loading = false;
        let payLoad = {accountNumber:this.accountNumber,bank:this.bank,bankname:this.bankName, accountName:this.accountName}
       this.$emit('toCustomization',payLoad)
      } else if (this.accountNumber == "") {
        this.message = "Enter Account Number";
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 1500);
        this.loading = false;
      } else if (this.bank == "") {
        this.message = "You need to select your bank";
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 1500);
        this.loading = false;
      } else if(this.accountName == undefined){
        this.message = "Your Bank details didn't resolve";
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 1500);
        this.loading = false;
      }
    },
  },
};
</script>

